import { render, staticRenderFns } from "./SettingsModule.vue?vue&type=template&id=00e93074"
import script from "./SettingsModule.vue?vue&type=script&lang=js"
export * from "./SettingsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports